import * as _ from 'underscore';
import { MapperHelper } from './MapperHelper';
import { ExplorableItemType } from '../models/ContentType';
import { IContentInfo } from '../models/IContentInfo';
import { ISharedWithMeContentInfo, ISharedWithMeCustomViewInfo, ISharerInfo } from '../models/ISharedWithMeContentInfo';
import { IUserInfo } from '../models/IUserInfo';
import { IShareAction } from '../ServerApi/requests/GetSharedWithMeRequest';

export module SharedWithMeMapper {

  export function map(
    shareActions: IShareAction[],
    content: _.Dictionary<_.Dictionary<IContentInfo<ExplorableItemType>>>,
    sharers: _.Dictionary<IUserInfo>,
    deletedSharers: _.Dictionary<IUserInfo>,
    viewsWithShareActivity: number[],
    customViews: _.Dictionary<ISharedWithMeCustomViewInfo>
  ): ISharedWithMeContentInfo[] {
    let contentInfos: ISharedWithMeContentInfo[] = [];
    shareActions.forEach((shareAction: IShareAction) => {
      // shareActions might contain references to contentIds that are not part of content due to inconsistency in the BE
      // so we need to verify the value is in content is not null
      const contentType = content[shareAction.contentType];
      if (contentType) {
        const currContent = contentType[shareAction.contentId];
        if (currContent) {
          const currSharer: ISharerInfo = shareAction.isSharerDeleted ?
            {
              ...deletedSharers[shareAction.sharerId],
              isDeleted: true
            } :
            {
              ...sharers[shareAction.sharerId],
              isDeleted: false
            };

          const isShareActivityIconVisible = currContent.contentType === 'view' && !!viewsWithShareActivity.includes(shareAction.contentId);

          // if the user does not have permissions to access the content, the sensitive fields that require
          // permissions to see are returned as null or undefined
          const isAccessDenied = !currContent.updatedAt && !currContent.createdAt && !currContent.luid;

          contentInfos.push({
            id:                         currContent.id,
            luid:                       currContent.luid,
            contentDetail:              currContent.contentDetail,
            contentType:                currContent.contentType,
            description:                currContent.description,
            favorite:                   currContent.favorite,
            name:                       currContent.name,
            owner:                      currContent.owner,
            thumbnailUrl:               currContent.thumbnailUrl,
            updatedAt:                  currContent.updatedAt,
            // Above data are required for IContentInfo
            // Following data are unique to ISharedWithMeContentInfo
            isShareActivityIconVisible: isShareActivityIconVisible,
            message:                    shareAction.message,
            sharedAt:                   MapperHelper.toDate(shareAction.createdAt),
            sharer:                     currSharer,
            isAccessDenied:             isAccessDenied,
            ...shareAction.underhoodCustomizedViewId ? {
              customView:               customViews[shareAction.underhoodCustomizedViewId]
            } : {},
          });
        }
      }
    });
    return contentInfos;
  }
}
